export const TAGS_GAP = 10;
export const MORE_LABEL_MAX_WIDTH = 25;
export const SHOW_MORE_LABEL_MAX_WIDTH = 90;
export const MORE_CHIP_LABEL_MAX_WIDTH = 60;
